
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.402 1.89L12.112.6l-5.11 5.111L1.89.601.6 1.888 5.713 7l-5.11 5.111 1.289 1.29L7 8.288l5.111 5.111 1.29-1.289-5.111-5.11 5.11-5.112z","fill":"red","fill-opacity":".7"}})])
          )
        }
      }
    